const settings = {
  "APP_NAME": "Global Opps",
  "API_URL": "https://flint-garage.glitch.me/api/",
  "AIRTABLE_ID": "appUxkIdcNy82aeJl"
}

export default settings


// WEBPACK FOOTER //
// ./src/settings.js